// Layout.tsx
import React, { ReactNode, useState } from 'react';
import Sidebar from './Sidebar';  // Import the Sidebar component
import Navbar from './Navbar';    // Import the Navbar component
import { t } from 'i18next';

interface LayoutProps {
  children: ReactNode;
  title:string,
  headline:string
}

const Layout: React.FC<LayoutProps> = ({ children,title,headline }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);

  return (
    <div className="flex max-h-screen">
      
      {/* Sidebar */}
      <Sidebar sidebarOpen={sidebarOpen} toggleSidebar={toggleSidebar} />

      {/* Main Content */}
      <div className="flex flex-col flex-1 overflow-x-hidden">
        
        {/* Navbar */}
        <Navbar toggleSidebar={toggleSidebar} title={title} headline={headline} />

        {/* Page Content */}
        <main className="flex-1 overflow-y-auto p-6">
          {children}
        </main>

      </div>

    </div>
  );
};

export default Layout;
